import { render, staticRenderFns } from "./OrdersPending.vue?vue&type=template&id=2b76fc42&"
import script from "./OrdersPending.vue?vue&type=script&lang=js&"
export * from "./OrdersPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b76fc42')) {
      api.createRecord('2b76fc42', component.options)
    } else {
      api.reload('2b76fc42', component.options)
    }
    module.hot.accept("./OrdersPending.vue?vue&type=template&id=2b76fc42&", function () {
      api.rerender('2b76fc42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/OrdersPending.vue"
export default component.exports